import { asSingleStyleConfig } from '../../utils/theme';
var baseStyle = {
  borderColor: '#f0f0f0'
};
var variantSolid = {
  borderStyle: 'solid'
};
var variantDashed = {
  borderStyle: 'dashed'
};
var variants = {
  solid: variantSolid,
  dashed: variantDashed
};
var defaultProps = {
  variant: 'solid'
};
export default asSingleStyleConfig({
  baseStyle,
  variants,
  colorSchemes: {
    gradient: {
      background: 'linear-gradient(to left, #ffffff 0%, #e9e9e9 2%, #e9e9e9 96%, #ffffff 100%)'
    },
    primary: {
      borderColor: 'blue.600'
    }
  },
  defaultProps
});